/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */




export const CustomerFlagDto = {
    Green: 'GREEN',
    Yellow: 'YELLOW',
    Red: 'RED',
} as const;

export type CustomerFlagDto = typeof CustomerFlagDto[keyof typeof CustomerFlagDto];



